import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const P2pPerformance = () => {
  const [formData, setFormData] = useState({
    purpose: "",
    orderId: "",
    documents: [],
    details: "",
  });

  const handleFileChange = (e) => {
    setFormData({ ...formData, documents: Array.from(e.target.files) });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted:", formData);
  };

  return (
   <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
        <Header />
         <div className="max-w-5xl mx-auto p-8 rounded-md shadow-sm">
      <form onSubmit={handleSubmit} className="space-y-8">
        {/* Section 1 */}
        <h3 className="text-lg font-semibold flex items-center gap-2">
          <span className="w-6 h-6 flex items-center justify-center rounded-full border border-gray-400 text-sm font-medium">
            1
          </span>
          Application Purpose <span className="text-red-500">*</span>
        </h3>
        <p className="text-sm text-gray-600 mb-2">
          Please select the purpose of your application
        </p>
        <select
          name="purpose"
          value={formData.purpose}
          onChange={(e) =>
            setFormData({ ...formData, purpose: e.target.value })
          }
          className="w-full border border-gray-300 rounded-md p-2 text-sm bg-transparent"
        >
          <option value="">Choose an option</option>
          <option value="Revert Order Completion">
            Revert Order Completion
          </option>
          <option value="Remove Negative Comment">
            Remove Negative Comment
          </option>
          <option value="Request Confirmation Receipts">
            Request Confirmation Receipts
          </option>
        </select>

        {/* Section 2 */}
        <h3 className="text-lg font-semibold flex items-center gap-2">
          <span className="w-6 h-6 flex items-center justify-center rounded-full border border-gray-400 text-sm font-medium">
            2
          </span>
          Relevant P2P Order(s) <span className="text-red-500">*</span>
        </h3>
        <p className="text-sm text-gray-600 mb-2">
          Please add the P2P order(s) relevant to this application. You can add
          up to 10 orders.{" "}
          <span className="text-yellow-500 cursor-pointer">
            Search Order History
          </span>
        </p>
        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Enter the order ID"
            value={formData.orderId}
            onChange={(e) =>
              setFormData({ ...formData, orderId: e.target.value })
            }
            className="flex-1 border border-gray-300 rounded-md p-2 text-sm bg-transparent"
          />
          <button
            type="button"
            className="bg-yellow-400 px-4 py-2 rounded-md font-medium hover:bg-yellow-500"
          >
            Add
          </button>
        </div>

        {/* Table */}
        <div className="overflow-x-auto border mt-4">
          <table className="w-full text-sm text-left border-collapse bg-transparent">
            <thead className="bg-gray-50 border-b bg-transparent">
              <tr>
                <th className="p-2">Order Number</th>
                <th className="p-2">Status</th>
                <th className="p-2">Crypto</th>
                <th className="p-2">Order Type</th>
                <th className="p-2">Fiat Amount</th>
                <th className="p-2">Unit Price</th>
                <th className="p-2">Crypto Amount</th>
                <th className="p-2">Match Time</th>
                <th className="p-2">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr className="text-gray-500">
                <td colSpan="9" className="p-3 text-center">
                  No item
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Section 3 */}
        <h3 className="text-lg font-semibold flex items-center gap-2">
          <span className="w-6 h-6 flex items-center justify-center rounded-full border border-gray-400 text-sm font-medium">
            3
          </span>
          Upload Supporting Document <span className="text-red-500">*</span>
        </h3>
        <p className="text-sm text-gray-600 mb-2">
          Upload the supporting document that will help us in the application
          review (e.g. chat record, payment transcript, or comment content)
        </p>
        <input
          type="file"
          multiple
          onChange={handleFileChange}
          className="block border border-gray-300 rounded-md p-2 text-sm"
        />
        <div>
            <p className="text-xs text-gray-500 pt-0 m-0">
          No more than 20 files. 
        </p>
        <p className="text-xs text-gray-500 pt-0 m-0">File size cannot exceed 30MB. </p>
        <p className="text-xs text-gray-500 pt-0 m-0"> Supported file formats are .jpg/.jpeg/.png/.mp4/.mov/.rmvb. </p>
        <p className="text-xs text-gray-500 pt-0 m-0">Please do not upload an encrypted file.</p>
        </div>

        {/* Section 4 */}
        <h3 className="text-lg font-semibold flex items-center gap-2">
          <span className="w-6 h-6 flex items-center justify-center rounded-full border border-gray-400 text-sm font-medium">
            4
          </span>
          Application Details <span className="text-red-500">*</span>
        </h3>
        <textarea
          rows="5"
          value={formData.details}
          onChange={(e) =>
            setFormData({ ...formData, details: e.target.value })
          }
          placeholder="[Order ID] - [Revert Order Completion / Remove Negative Comment / Request P2P Order Confirmation Receipts] - [Reason] - [Supporting Document File Name(s)]"
          className="w-full border border-gray-300 rounded-md p-2 text-sm bg-transparent"
        />

        {/* Buttons */}
        <div className="flex justify-end space-x-3">
          <button
            type="button"
            className="px-6 py-2 border border-gray-300 rounded-md bg-gray-100 text-gray-700 hover:bg-gray-200"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-6 py-2 rounded-md bg-yellow-400 text-black font-medium hover:bg-yellow-500"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
        <Footer />
   </div>
  );
};

export default P2pPerformance;
